var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg26(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2891_50082)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.4706H20V20H0V16.4706ZM1.17647 17.6471V18.8235H18.8235V17.6471H1.17647Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.47058 2.94118C6.47058 1.31681 7.78739 0 9.41175 0H10.5882C12.2126 0 13.5294 1.31681 13.5294 2.94118V6.47059C13.5294 8.42871 11.9348 10.0144 9.97342 9.99991M9.41175 1.17647C8.43714 1.17647 7.64705 1.96656 7.64705 2.94118V6.43369C7.64705 7.74198 8.69312 8.81396 9.98209 8.82347C11.2899 8.83316 12.3529 7.77607 12.3529 6.47059V2.94118C12.3529 1.96656 11.5628 1.17647 10.5882 1.17647H9.41175Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9412 5.29412H7.05881V4.11765H12.9412V5.29412Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8824 5.29412H12.9412V4.11765H15.8824V5.29412Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.63644 12.2249C6.6364 12.2249 6.63648 12.2249 6.63644 12.2249L5.6951 12.4179C4.76746 12.6552 4.11763 13.4914 4.11763 14.4502V16.4706H15.8823V14.4502C15.8823 13.4914 15.2325 12.6552 14.3049 12.4179L13.3635 12.2249C13.3635 12.2249 13.3636 12.2249 13.3635 12.2249C11.8808 11.9212 10.7827 10.6997 10.6117 9.22581L11.7804 9.09027C11.8934 10.0642 12.6196 10.8716 13.5996 11.0724L14.5665 11.2706L14.5787 11.2736C16.0363 11.6379 17.0588 12.9478 17.0588 14.4502V17.6471H2.94116V14.4502C2.94116 12.9477 3.96364 11.6379 5.42128 11.2736L5.43347 11.2706L6.40028 11.0724C7.38028 10.8717 8.10662 10.0642 8.21959 9.09027L9.38822 9.22581C9.21728 10.6997 8.11913 11.9212 6.63644 12.2249Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53385 11.3069L8.36574 10.475L9.99999 12.1093L11.6342 10.475L12.4661 11.3069L9.99999 13.7731L7.53385 11.3069Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41177 17.0588V12.9412H10.5882V17.0588H9.41177Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.76471 6.47059C1.43983 6.47059 1.17647 6.73395 1.17647 7.05882C1.17647 7.3837 1.43983 7.64706 1.76471 7.64706C2.08958 7.64706 2.35294 7.3837 2.35294 7.05882C2.35294 6.73395 2.08958 6.47059 1.76471 6.47059ZM0 7.05882C0 6.0842 0.790086 5.29412 1.76471 5.29412C2.73933 5.29412 3.52941 6.0842 3.52941 7.05882C3.52941 8.03344 2.73933 8.82353 1.76471 8.82353C0.790086 8.82353 0 8.03344 0 7.05882Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.35294 2.71328L4.8919 3.5596L4.51987 4.6757L3.52941 4.34555V7.05882H2.35294L2.35294 2.71328Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.47058 15.2941V17.0588H5.2941V15.2941H6.47058Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7059 15.2941V17.0588H13.5294V15.2941H14.7059Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2891_50082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg26);
export default __webpack_public_path__ + "static/media/26.c52fd2b48f1a98a47c9438aa28cccf46.svg";
export { ForwardRef as ReactComponent };